import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";
import type CnamProcessStartedJournalEvent from "./cnam-process-started-journal-event";

//---- Automatically generated, don't update this part ----

/**
 * Describe a call to the INSi service, wether it was a success or not.
 * It may results in the patient's administrative informations being updated, in case of success.
 */
export default class InsRetrievedJournalEvent extends JournalEvent {
  static override type = "ins-retrieved-journal-event";

  /**
   * The identity returned by the service.
   * Described as `InsIdentityResult` by `lib/cnam/addon/services/insi.ts`
   */
  @attr() declare identity: any;

  /**
   * Wether the call to the INSi service was a success or not
   */
  @attr("boolean", {
    allowNull: true
  })
  declare succeed: boolean;

  @belongsTo("cnam-process-started-journal-event", {
    async: false,
    inverse: "insRetrievedJournalEvent"
  })
  declare cnamProcessStartedJournalEvent: CnamProcessStartedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      identity: validatePresence({
        presence: true,
        description: intl.t("validations.ins-retrieved-journal-event.identity")
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.ins-retrieved-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "ins-retrieved-journal-event": InsRetrievedJournalEvent;
  }
}
